<template>
  <ul class="gallery-software-list">
    <li
      class="software-wrapper"
      v-for="(softwareItem, index) in software">

      <router-link :to="{ name: 'galleries', query: { software: '' + softwareItem.id } }">
        <gallery-software :software="softwareItem">
        </gallery-software>
      </router-link>
    </li>
  </ul>
</template>

<script>
  import GallerySoftware from './GallerySoftware';

  export default {
    name: 'gallery-software-list',

    components: { GallerySoftware },

    props: {
      software: {
        type: Array,
        // [ { id, name, iconUrl } ]
      }
    },

    data() {
      return {};
    }
  }
</script>

<style lang="scss" scoped>
  .gallery-software-list {
    padding-top: 10px;
  }

  .software-wrapper {
    display: inline-block;
    vertical-align: top;

    > a {
      display: block;
      height: 100%;
      padding: 10px 5px;

      &:hover {
        background-color: #333333;
        text-decoration: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GallerySoftwareList.vue?16b8dd09